import { motion } from 'framer-motion';


export default function Portfolio() {
  // Import images directly
  const logos = [
    { src: require('../assets/carrytoo.png'), alt: 'Carrytoo' },
    { src: require('../assets/chessbrigade.png'), alt: 'Chess Brigade' },
    { src: require('../assets/Talebisi.png'), alt: 'Talebisi' }
  ];

  // Duplicate logos for seamless scrolling
  const scrollingLogos = [...logos, ...logos, ...logos];

  return (
    <section id="brands" className="py-12 overflow-hidden bg-black bg-gradient-to-b from-black via-gray-900 to-black">
      <div className="container mx-auto">
        <motion.h2
          initial={{ y: 20, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          className="text-3xl md:text-4xl font-display font-bold text-center mb-16"
        >
          <span className="bg-gradient-to-r from-green-400 via-primary to-green-400 bg-clip-text text-transparent">
            Brands That Trust Us
          </span>
        </motion.h2>

        {/* Single row - moving left */}
        <div className="relative w-full overflow-hidden">
          <motion.div
            className="flex items-center justify-start space-x-20 whitespace-nowrap min-w-max"
            animate={{
              x: [0, '-50%']
            }}
            transition={{
              duration: 20,
              ease: "linear",
              repeat: Infinity
            }}
          >
            {scrollingLogos.map((logo, index) => (
              <motion.div
                key={`${logo.alt}-${index}`}
                className="inline-block"
                whileHover={{ scale: 1.1 }}
                transition={{ duration: 0.3 }}
              >
                <div className="group block p-8">
                  <img
                    src={logo.src}
                    alt={logo.alt}
                    className="h-20 w-auto object-contain opacity-80 group-hover:opacity-100 transition-opacity duration-300"
                  />
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
